import { combineReducers } from 'redux';
import getUsers from 'store/reducers/user/get-users';
import getRoles from 'store/reducers/user/get-roles';
import postUser from 'store/reducers/user/post-user';
import getUser from 'store/reducers/user/get-user';
import getStatuses from 'store/reducers/user/get-statuses';
import getUserActivityLogs from 'store/reducers/user/get-user-activity-logs';
import getUsersTableFilters from 'store/reducers/user/get-users-table-filters';

export default combineReducers({
  getUsers,
  getRoles,
  postUser,
  getUser,
  getStatuses,
  getUserActivityLogs,
  getUsersTableFilters,
});